<button [ngStyle]="{'scale': scale}" (click)="navigateBack()">
    <img src="../../../../../assets/icons/back.svg"/>
</button>